// Le studio d'une marque : la création (assistant), la configuration et la
// collecte, les concurrents, les personas, les carrefours d'audience,
// l'annuaire des auteurs et les dérives.
export default {
  commun: {
    fermer: 'fermer',
    annuler: 'annuler',
    ajouter: 'Ajouter',
    direct: 'direct',
    aspirationnel: 'aspirationnel',
    verifie: 'vérifié',
    aVerifier: 'à vérifier',
    urlCompte: 'URL du compte',
    inclusion: 'Mots-clés d\'inclusion',
    exclusion: 'Mots-clés d\'exclusion',
    plateforme: 'Plateforme :',
    toutes: 'Toutes',
    tous: 'Tous',
    nomConcurrent: 'Nom du concurrent',
    retenus: '{n} retenu(s)',
    lancementImpossible: 'Lancement impossible',
    sauvegardeImpossible: 'Sauvegarde impossible',
    suppressionImpossible: 'Suppression impossible',
    suggestionImpossible: 'Suggestion impossible',
    nonSegmente: 'Non segmenté',
    confiance: 'confiance',
    citation: '« {texte} »',
  },
  // Les libellés de plateforme qui ne sont pas des noms propres.
  plateformes: {
    website: 'Site web',
  },
  // Ce qu'on attend dans le champ URL d'un compte officiel, par plateforme.
  indicesComptes: {
    youtube: "Channel URL (e.g. https://www.youtube.com/{'@'}inoxtag or /channel/UCxxx).",
    twitch: 'Chaîne Twitch (ex. https://www.twitch.tv/kamet0).',
    x: 'Profile URL (e.g. https://x.com/inoxtag).',
    instagram: 'Profile URL (e.g. https://www.instagram.com/inoxtag).',
    linkedin: 'Company page or profile (e.g. https://www.linkedin.com/company/orion or /in/jane-doe).',
    tiktok: "Profile URL (e.g. https://www.tiktok.com/{'@'}inoxtag).",
    website: 'Site officiel (ex. https://www.kcorp.gg) - utilisé par les ISOs en mode Arène.',
    app_store: 'Fiche App Store (ex. https://apps.apple.com/fr/app/mon-jeu/id1542776143) - les avis publics sont collectes gratuitement.',
    google_play: 'Fiche Google Play (ex. https://play.google.com/store/apps/details?id=com.mon.jeu) - les avis publics sont collectes gratuitement.',
  },
  // Ce qu'on attend dans le champ URL d'une page à collecter, par plateforme.
  indicesPages: {
    instagram: 'Lien Instagram (post /p/, reel /reel/ ou profil).',
    x: 'Lien d\'un statut X / Twitter uniquement (https://x.com/.../status/...). Profils non supportés.',
    trustpilot: 'Page de reviews Trustpilot de la marque (https://www.trustpilot.com/review/...).',
    amazon_reviews: "URL d'un produit Amazon (https://www.amazon.com/.../dp/{'<'}ASIN{'>'}).",
    youtube_video: 'URL d\'une vidéo YouTube (watch?v=... ou youtu.be/...).',
    linkedin: 'URL d\'un post LinkedIn (linkedin.com/posts/..., /pulse/... ou /feed/update/...). Profils et pages company non supportés.',
  },
  wizard: {
    titre: 'Nouvelle marque',
    sousTitre: '4 étapes · la marque est créée à la dernière, rien avant',
    etapes: {
      identite: 'Identité',
      comptes: 'Comptes & présences',
      concurrents: 'Concurrents',
      recap: 'Récapitulatif',
    },
    seuilPermissif: 'permissif - plus de signaux, plus de bruit',
    seuilStrict: 'strict - moins de bruit, risque de rater des signaux',
    seuilEquilibre: 'équilibré',
    attenteCadrage: 'attente du cadrage…',
    comptesProposes: '{n} compte proposé | {n} compte proposé | {n} comptes proposés',
    dejaRenseignees: 'les plateformes trouvées sont déjà renseignées',
    aucunCompteTrouve: 'aucun compte trouvé avec assez de certitude - ajoutez-les à la main',
    marqueCreeEchecs: 'Marque créée. Concurrents non inscrits : {liste} - à ajouter depuis son écran.',
    creationImpossible: 'Création impossible',
    nomRequis: 'Le nom de la marque est requis.',
    dossierHote: 'Cette marque sera celle du dossier {dossier}.',
    dossierPris: 'Le dossier {dossier} a déjà sa marque : celle-ci recevra son propre dossier, à son nom (une marque par dossier).',
    sansDossier: 'Cette marque recevra son propre dossier, à son nom.',
    nomMarque: 'Nom de la marque',
    categorie: 'Catégorie',
    choisir: '- choisir -',
    secteur: 'Secteur',
    secteurExemple: 'Gaming / divertissement',
    description: 'Description',
    descriptionExemple: 'Nouvelle IP shorts autour du patrimoine vidéoludique français.',
    descriptionAide: 'Elle sert à désambiguïser la marque de ses homonymes - une phrase précise vaut mieux qu\'un paragraphe.',
    langue: 'Langue',
    pays: 'Pays',
    suggererComptesTitre: 'Orion cherche les comptes officiels de la marque',
    recherche: 'Recherche… {s} s',
    suggestionOrion: 'Suggestion Orion',
    detectes: 'Détectés depuis le nom et la description - vérifiez chaque URL.',
    attenteRecherche: 'Orion cherche les comptes officiels sur le web - une trentaine de secondes en général,',
    plusLong: 'plus long que d\'habitude, la recherche est relancée automatiquement si elle traîne',
    parfois: 'parfois davantage.',
    comptesMarque: 'Comptes de la marque',
    comptesMarqueAide: 'Ses propres canaux, site web compris. Leur contenu est collecté SANS filtre : il parle d\'elle par construction.',
    pages: 'Pages à collecter',
    pagesAide: 'Des pages précises où on parle d\'elle : une fiche Trustpilot, un produit Amazon, une vidéo. Leur contenu PASSE par le filtre de désambiguïsation.',
    autres: 'Autres présences',
    autresAide: 'Bluesky, un Discord, une page presse… Notées au dossier de la marque, mais {pasCollectees} : aucun connecteur ne sait lire une plateforme arbitraire.',
    pasCollectees: 'pas collectées',
    nonCollecte: 'non collecté',
    nomPlateforme: 'Nom de la plateforme',
    suggererConcurrentsTitre: 'Orion analyse le secteur et propose des concurrents',
    analyseSecteur: 'Analyse du secteur…',
    decochez: 'Décochez ce que vous ne retenez pas.',
    aucunConcurrent: 'Aucun concurrent pour l\'instant - lancez la suggestion, ou ajoutez-en un à la main.',
    saisi: 'saisi',
    sansJustification: 'Proposé sans justification - à vérifier avant de le retenir.',
    urlFacultative: 'URL (facultative)',
    vaEtreCree: 'Ce qui va être créé',
    sansQualification: 'sans qualification',
    nbComptes: 'compte(s) de la marque',
    nbPages: 'page(s) à collecter',
    nbConcurrents: 'concurrent(s) retenu(s)',
    autresNotees: '{n} autre(s) présence(s) notée(s), non collectée(s).',
    desambiguisation: 'Désambiguïsation',
    analyseEnCours: 'analyse en cours…',
    detectee: 'détectée',
    echecRelancer: 'échec - relancer',
    masquer: 'Masquer',
    avances: 'Avancés',
    aucuneDesamb: 'Aucune désambiguïsation - la collecte ne saura pas distinguer la marque de ses homonymes.',
    seuleChose: 'C\'est la seule chose du parcours dont une mauvaise valeur contamine TOUS les scores en aval. Relisez-la.',
    desambExemple: 'Ce qu\'est la marque, et ce qu\'elle n\'est pas.',
    alias: 'Alias',
    aliasExemple: 'autre écriture du nom',
    inclusionExemple: 'un signal doit contenir…',
    exclusionExemple: 'jamais confondre avec…',
    seuil: 'Seuil',
    auditTitre: 'Lance l’audit complet dès la marque créée',
    lancerAudit: 'Lancer l’audit complet immédiatement',
    collecteSources: 'La collecte de toutes les sources, puis les personas, les scores et la présence IA.',
    collecteSourcesN: 'La collecte de toutes les sources ({n} connecteurs), puis les personas, les scores et la présence IA.',
    sinon: 'Sinon, la marque est créée et vous lancez l’audit depuis son écran quand vous voulez.',
    creeTitre: 'Crée la marque',
    creation: 'Création…',
    creerEtLancer: 'Créer la marque et lancer l’audit',
    creer: 'Créer la marque',
    precedent: '← Précédent',
    suivant: 'Suivant →',
  },
  config: {
    titre: 'Configuration & ingestion',
    sousTitre: '{marque} · pipelines par plateforme, mots-clés, partage',
    niveaux: {
      galaxy: 'Galaxie',
      solar_system: 'Système solaire',
      planet: 'Planète',
    },
    changerMarque: 'changez de marque via le sélecteur de la sidebar',
    lancerAuditTitre: 'Lance un audit complet de la marque - suivi sur la page Audits. La collecte est sautée automatiquement si les données sont récentes.',
    lancement: 'Lancement…',
    lancerAudit: 'Lancer un audit',
    ingestionsEnCours: '{n} ingestion en cours | {n} ingestion en cours | {n} ingestions en cours',
    statuts: {
      done: 'done',
      running: 'running',
      error: 'error',
      cancelled: 'annulé',
      never: 'jamais lancé',
    },
    enCours: 'en cours…',
    dernierRun: 'dernier run · {date}',
    collectes: 'collectés',
    retenus: 'retenus',
    ecartes: 'écartés',
    doublons: 'doublons',
    vides: '{n} vides',
    videsTitre: 'Contenus collectés inexploitables (texte manquant ou format inattendu) - ils ne deviennent jamais des signaux.',
    erreursCollecte: '{n} erreurs de collecte',
    erreursTitre: 'La collecte n\'a rien ramené d\'exploitable (page vide, aucun résultat…). Réessayez plus tard ou ajustez les mots-clés / URLs.',
    lancerTitre: 'Lance la collecte de cette source',
    lancer: 'Lancer',
    reseaux: 'Réseaux, sites et comptes officiels',
    enregistrement: 'enregistrement…',
    enregistrementImpossible: 'Enregistrement impossible',
    reseauxAide: 'La collecte les lit, et les ISOs s’en servent : l’Arène fait défiler la chaîne YouTube de la marque et passe par ses présences officielles.',
    aucunCompte: 'Aucun compte. Les boutiques d\'applications comptent : leurs avis sont la source la plus riche pour une application, et ils sont gratuits.',
    autre: 'Autre',
    verifieTitre: 'Vérifié - cliquer pour marquer à vérifier',
    proposeTitre: 'Proposé par Orion sans confirmation - cliquer pour valider',
    retirerCompteTitre: 'Retirer ce compte - sa collecte s’arrête, les signaux déjà recueillis restent',
    ajouterCompteTitre: 'Ajouter un compte officiel',
    ajouterCompte: '+ ajouter un compte',
    urlsSuivies: 'URLs suivies · {n}',
    autresUrls: '+ {n} autres…',
    aucuneUrl: 'Aucune URL suivie.',
    ajouterMotCle: '+ ajouter',
    analyseAuto: 'Analyse automatique',
    cadenceTitre: 'Cadence des audits automatiques - exécutés par le scheduler backend',
    cadences: {
      manual: 'Manuelle (jamais)',
      daily: 'Quotidienne',
      weekly: 'Hebdomadaire',
      biweekly: 'Toutes les 2 semaines',
      monthly: 'Mensuelle',
    },
    concurrentsLeger: 'Concurrents en léger',
    schedulerAide: 'Le scheduler relance ingestion + analyse à cette cadence (nécessite ENABLE_ORION_V3_SCHEDULER=true côté serveur).',
    partage: 'Partage de la marque',
    emailExemple: "email{'@'}exemple.fr",
    lecteur: 'Lecteur',
    editeur: 'Éditeur',
    partagerTitre: 'Partage la marque avec ce compte',
    inviter: 'Inviter',
    invitationImpossible: 'Invitation impossible',
    retirerPartage: 'Retirer ce partage',
    sur: 'Sûr ? Cette action est définitive.',
    supprimerAide: 'Supprimer la marque efface la config et les scores agrégés.',
    supprimerTitre: 'Supprime la marque, sa config et ses scores agrégés',
    suppression: 'Suppression…',
    confirmer: 'Confirmer',
    supprimer: 'Supprimer',
    cible: 'cible : {cible} · durée {duree}',
  },
  concurrents: {
    titre: 'Concurrents',
    auTotal: '{n} au total',
    fixent: 'ils fixent la moyenne de référence des 4R',
    aucunTrouve: 'Aucun concurrent trouvé avec assez de certitude : ajoutez-les à la main.',
    detectionImpossible: 'Détection impossible',
    ajoutImpossible: 'Ajout impossible',
    basculeImpossible: 'Bascule impossible',
    changementImpossible: 'Changement impossible',
    retraitImpossible: 'Retrait impossible',
    ceConcurrent: 'ce concurrent',
    confirmerRetrait: 'Retirer {nom} définitivement ?\n\n« Écarter » suffit pour l\'exclure des scores : il reste dans l\'historique.',
    concurrentLie: 'concurrent lié',
    site: 'site ↗',
    directTitre: 'Direct : il se dispute vos spectateurs maintenant. Cliquer pour le passer en aspirationnel.',
    aspirationnelTitre: 'Aspirationnel : hors de portée aujourd’hui, il sert de repère. Cliquer pour le passer en direct.',
    retenuTitre: 'Retenu : il compte dans la moyenne de référence. Cliquer pour l’écarter.',
    ecarteTitre: 'Écarté : il ne compte pas dans les scores. Cliquer pour le retenir.',
    retenu: 'retenu',
    ecarte: 'écarté',
    suggere: 'suggéré',
    retirerTitre: 'Retirer définitivement : « écarter » suffit pour l’exclure des scores',
    aucun: 'Aucun concurrent. Sans eux, la moyenne de référence des 4R n’a rien à quoi se comparer.',
    detecterTitre: 'Orion cherche les concurrents sur le web et les inscrit en « suggéré » : à vous de trancher',
    detection: 'Détection… {s} s',
    detecter: 'Détecter automatiquement',
    rechercheEnCours: 'recherche web en cours, jusqu’à trois minutes',
    arriventSuggere: 'ils arrivent en « suggéré » : à vous de retenir ou d’écarter',
    urlExemple: 'site ou compte (optionnel)',
    ajouterTitre: 'Inscrit ce concurrent : il comptera dans la moyenne de référence',
    ajout: 'ajout…',
  },
  personas: {
    titre: 'Parler aux personas',
    sousTitre: 'Parler aux personas de vos audiences',
    suggestions: {
      formatCourt: 'Que penses-tu d\'un nouveau format court sur ce sujet ?',
      desabonner: 'Qu\'est-ce qui te ferait te désabonner ?',
    },
    testImpossible: 'Test impossible',
    verdicts: {
      aligned: 'Compatible',
      partial: 'Partiel',
      misaligned: 'Tension déclenchée',
    },
    sourceTitre: 'Personas construites depuis votre audience - calcul du {date}',
    chargement: 'Chargement des personas…',
    nonCalculees: 'Personas non calculées pour cette marque - lancez une analyse complète d\'abord.',
    part: 'part',
    tropEpars: 'signaux trop épars pour former une persona',
    nouvelleConversation: 'Nouvelle conversation',
    posezMoi: 'Posez-moi une question - je réponds avec le vocabulaire de mon segment.',
    ecrireA: 'Écrire à {nom}…',
    pressureExemple: 'Pressure-tester une idée contre toutes les personas…',
    analyse: 'Analyse…',
    tester: 'Tester',
    reco: 'Reco :',
    confiancePct: 'confiance {n}%',
  },
  carrefours: {
    titre: 'Carrefours d\'audience',
    sousTitre: 'Co-mentions : ce que vos audiences citent en commun',
    intro: 'Ce que l\'audience mentionne en commun - observé sur les auteurs de votre audience.',
    auteursUniques: '{n} auteurs uniques',
    type: 'Type :',
    types: {
      handle: 'compte',
      hashtag: 'hashtag',
      proper_noun: 'nom propre',
    },
    agregation: 'Agrégation des co-mentions…',
    aucun: 'Aucun carrefour détecté - il faut plusieurs auteurs mentionnant la même entité.',
    mentions: 'mentions',
    auteurs: 'auteurs',
    couverture: 'couverture',
    mentionsPar: '{m} mentions par {a} auteurs distincts',
  },
  auteurs: {
    titre: 'Annuaire des auteurs',
    sousTitre: 'Les auteurs derrière les signaux de la marque courante',
    persona: 'Persona :',
    auteursDistincts: '{n} auteurs distincts',
    topAffiche: 'top {n} affiché',
    colAuteur: 'Auteur',
    colPlateforme: 'Plateforme',
    colSignaux: 'Signaux',
    colSentiment: 'Sentiment',
    colDernier: 'Dernier signal',
    trierSignaux: 'Trier par signaux',
    trierSentiment: 'Trier par sentiment moyen',
    agregation: 'Agrégation des auteurs…',
    moyenneSur: 'moyenne sur {n} signaux scorés',
    nonCalcule: 'sentiment non calculé',
    aucun: 'Aucun auteur - élargissez les filtres ou lancez une ingestion.',
    ouvrezDossier: 'Ouvrez un dossier dans la barre latérale : l’annuaire est celui de sa marque.',
  },
  drifts: {
    sousTitre: 'Dérives détectées entre deux audits · cross-marques',
    marque: 'Marque :',
    severite: 'Sévérité :',
    severites: {
      err: 'critique',
      warn: 'modérée',
      ok: 'info',
    },
    analyse: 'Analyse des snapshots…',
    aucune: 'Aucune dérive - la stabilité aussi est une info.',
    types: {
      retention: 'chute rétention',
      resonance: 'chute résonance',
      persona: 'drift persona',
      white_space: 'white space',
    },
    ouvrirAudits: 'Ouvrir les audits',
  },
}
